import React, { Component } from 'react';

class LoadingScreen extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return <div>Loading</div>;
  }
}

export default LoadingScreen;
